import axios from "../plugins/parseAxios";
export class CommentAPI {
  constructor(props) { }
  static createComment(payload) {
    return axios.post("functions/createComment", payload);
  }
  static getCommentByPost({ postId }) {
    return axios.post("functions/getCommentByPost", { postId });
  }
}
